import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'

export const JumpToLinksBlockFragment: BlockFragment = {
  name: 'jumpToLinks',
  fragment: gql`
    fragment jumpToLinks on JumpToLinks {
      id
      blockName
      blockType
      jumpToLinkHeading: heading
      links {
        text
        jumpsTo
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on JumpToLinks {
      id
      blockName
      blockType
      jumpToLinkHeading: heading
      links {
        text
        jumpsTo
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const JumpToLinksBlockType = 'jumpToLinks'

export interface JumpToLinksBlock extends BaseBlock {
  blockType: typeof JumpToLinksBlockType
  jumpToLinkHeading: string
  links: {
    text: string
    jumpsTo: string
  }[]
}
